/**
 * UTIL FUNCTION THAT CAN EASY TO USE IN EVERY CLASS
 **/

export const cloneArray = (arrays: Array<any>): Array<any> => {
  if (arrays.length) {
    let clone: Array<any> = [];

    arrays.forEach(item => clone.push(Array.isArray(item) ?
      cloneArray(item) : typeof item === 'object' ? Object.assign({}, item) : item));

    return clone;
  }

  return [];
};

/**
 * return props for paging
 *
 * @param current
 * @param max
 */
export const countPagination = function(current: any, max: any) {
  if (max <= 8) {
    return new Array(max).fill(null).map((_, i) => {
      const value = i + 1;
      let btnClassName = 'pagination-link';
      if (current === value) {
        btnClassName += ' is-current';
      }

      return {
        value,
        btnClassName,
        isDisable: false
      }
    });
  } else {
    let delta = 2, range = [], rangeWithDots = [], l;

    range.push(1);
    for (let i = current - delta; i <= current + delta; i++) {
      if (i < max && i > 1) {
        range.push(i)
      }
    }
    range.push(max);

    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1)
        } else if (i - l !== 1) {
          rangeWithDots.push('...')
        }
      }

      rangeWithDots.push(i);
      l = i
    }

    return rangeWithDots.map((item) => {
      let btnClassName = `pagination-${item === '...' ? 'ellipsis' : 'link'}`;
      if (current === item) btnClassName += ' is-current';

      return {
        value: item,
        btnClassName,
        isDisable: item === '...'
      }
    })
  }
};

export const getForegroundColorByBg = function (hexcolor: string) {
  const hexcolorCopy = hexcolor.replace("#", "");

  const r = parseInt(hexcolorCopy.substr(0, 2), 16);
  const g = parseInt(hexcolorCopy.substr(2, 2), 16);
  const b = parseInt(hexcolorCopy.substr(4, 2), 16);
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

  return (yiq >= 128) ? 'black' : 'white';
};

/**
 * Deselect object on given param
 */
export const omit = (param: any = {}, omits: Array<string>): any => {
  let params: any = {};
  Object.keys(param).forEach(item => {
    if (!omits.includes(item)) {
      params[item] = param[item];
    }
  });

  return params;
};

/**
 * Remove certain node element
 */
export const removeElement = (el: any) => {
  if (typeof el.remove === 'function') {
    el.remove()
  } else if (typeof el.parentNode !== 'undefined') {
    el.parentNode.removeChild(el)
  }
};

/**
 * Get value of an object property/path even if it's nested
 */
export const getValueByPath = (obj: any, path: any) => {
  return path.split('.').reduce((o: any, i: any) => o[i], obj);
};

/**
 * Escape regex characters
 * http://stackoverflow.com/a/6969486
 */
export const escapeRegExpChars = (value: any) => {
  if (!value) return value;

  // eslint-disable-next-line
  return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
};

/**
 * return formated list from key
 * as key from label and value for value
 * use this with card info
 *
 * @param param
 */
export const toListFormated: any = (param: any) => {
  let paramFormated: any = Object.assign({}, param);

  return Object.keys(paramFormated).map((item: any) => {
    return {label: item, value: paramFormated[item]}
  });
};

/**
 * generate unique random word
 */
export const generateGUID = () => {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
};

export const htmlToTag: Function = (param: string) => {
  let paramFormated: string = param.replace(/<[^>]+>/g, '');

  return paramFormated.replace(/&#(\d+);/g, function (match, dec) {
    return String.fromCharCode(dec);
  });
};

export const getLatLng: any = (): any => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      const options: any = {
        enableHighAccuracy: true,
        timeout: 10000
      };
      navigator.geolocation.getCurrentPosition((position) => {
        resolve(position);
      }, (err) => reject(err), options);
    } else {
      reject(new Error('Lat lng is not supported in current browser'));
    }
  });
};

/**
 * get base 64 from file image
 *
 * @param file
 */
export const getBase64File = file => new Promise((resolve, reject) => {
  const reader = new FileReader();

  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

/**
 * get images base64 from url
 *
 * @param img
 * @param width
 * @param height
 */
export const getBase64ImageUrl = (img: any, width: number = null, height: number = null): string => {
  if (img) {
    // Create an empty canvas element
    let canvas = document.createElement("canvas");
    canvas.width = width || img.width;
    canvas.height = height || img.height;

    // Copy the image contents to the canvas
    let ctx = canvas.getContext("2d");

    ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight,
      0, 0, canvas.width, canvas.height);

    return canvas.toDataURL("image/jpeg");
  }

  return "";
};

export const standardDeviation = (values: Array<number>) => {
  let avg = averageVals(values);

  let squareDiffs = values.map(function (value) {
    let diff = value - avg;

    return diff * diff;
  });

  let avgSquareDiff = averageVals(squareDiffs);

  return Math.sqrt(avgSquareDiff);
};

export const averageVals = (data: Array<number>) => {
  let sum = data.reduce(function (sum, value) {
    return sum + value;
  }, 0);

  return sum / data.length;
};

export const shuffleArray = (data: Array<any>) => {
  for (let i = data.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [data[i], data[j]] = [data[j], data[i]];
  }

  return data;
};
